import React from 'react';
import _ from 'underscore';

export default function SwensensHR({ additionalStyles = {} }) {
    return (
        <hr style={_.extend({ color: 'var(--swensens-brand-color)', opacity: 1, borderTop: '3px solid' }, additionalStyles)}/>
    )
}
